import { WorkBook } from 'xlsx-js-style';
import { ExcelTemplate } from '../../interfaces';
import { withHeaderStyling } from '../../utils';
import { fitToColumn } from '../financial-statement/utils';
import { getPreparedData } from './mapping';
import * as XLSX from 'xlsx-js-style';
import {
  NetIrrWrapper,
} from '../../../fund-performance/component/fund-performances/fund-performance-card/fund-performance-card.component';

export class InvestorContributionTemplate implements ExcelTemplate {
  export(data: NetIrrWrapper): WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }


  private getSheet(exportExcelData: NetIrrWrapper): XLSX.WorkSheet {
    const headers = this.getHeaders();
    const preparedData = getPreparedData(exportExcelData, headers);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    return withHeaderStyling(sheet);
  }

  private getHeaders(): string[] {
    return ['Code', 'Investor', 'Date', 'Type', 'Contribution'];
  }
}
